/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { atom, createStore } from "jotai";
import { type canva } from "common/utils/models/canva.types";

export const $fileInputAtom = atom<HTMLInputElement | null>(null);
export const $modalAtom = atom<HTMLElement | null>(null);
export const designsAtom = atom<{ continuation: string | undefined; items: canva.designs.Item[] }>({
  continuation: undefined,
  items: []
});
export const errorAtom = atom<string | null>(null);
export const intervalIdAtom = atom<ReturnType<typeof setInterval> | null>(null);
export const loadingAtom = atom<boolean>(false);
export const settingsAtom = atom<canva.settings.Response | Record<string, never>>({});
export const uploadingAtom = atom<boolean>(false);

export const jotaiStore = createStore();
